/** Gerador pseudoaleatório determinístico (mulberry32). O estado inteiro cabe em um número, então entra no save. */
export class Rng {
  private s: number;

  constructor(semente: number) {
    this.s = semente >>> 0;
  }

  get estado(): number {
    return this.s;
  }

  set estado(v: number) {
    this.s = v >>> 0;
  }

  /** Real em [0, 1). */
  proximo(): number {
    this.s = (this.s + 0x6d2b79f5) >>> 0;
    let t = this.s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Inteiro em [0, n). */
  inteiro(n: number): number {
    return Math.floor(this.proximo() * n);
  }

  /** Inteiro em [a, b], inclusive. */
  faixa(a: number, b: number): number {
    return a + this.inteiro(b - a + 1);
  }

  chance(p: number): boolean {
    return this.proximo() < p;
  }

  escolher<T>(itens: readonly T[]): T {
    if (itens.length === 0) throw new Error('lista vazia');
    return itens[this.inteiro(itens.length)] as T;
  }

  /** Sorteia um índice proporcional aos pesos (pesos <= 0 nunca são sorteados, salvo se todos forem). */
  ponderado(pesos: readonly number[]): number {
    let total = 0;
    for (const p of pesos) total += p > 0 ? p : 0;
    if (total <= 0) return this.inteiro(pesos.length);
    let r = this.proximo() * total;
    for (let i = 0; i < pesos.length; i++) {
      const p = pesos[i] as number;
      if (p <= 0) continue;
      if (r < p) return i;
      r -= p;
    }
    return pesos.length - 1;
  }

  /** Normal (Box-Muller). */
  normal(media: number, desvio: number): number {
    const u = 1 - this.proximo();
    const v = this.proximo();
    return media + desvio * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
  }

  embaralhar<T>(itens: T[]): T[] {
    for (let i = itens.length - 1; i > 0; i--) {
      const j = this.inteiro(i + 1);
      const a = itens[i] as T;
      itens[i] = itens[j] as T;
      itens[j] = a;
    }
    return itens;
  }
}
